import { Injectable } from '@angular/core';
import { Endpoints } from 'src/environments/endpoints';
import { ConsumeService } from './consume.service';
import { map, Observable } from 'rxjs';
import { IContacts, IContactsUpdate } from '../pages/buro/interfaces/IContacts';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FinalStatusService {

  constructor(private consume: ConsumeService, private http: HttpClient) { }

  getContacts(idKeycloak: string): Observable<IContacts> {
    return this.consume.httpGet(`${Endpoints.clientes.base}/contact/${idKeycloak}`).pipe(
      map( (resp:any) => resp.data )
    );
  }

  updateContacts(body: IContactsUpdate): Observable<any> {
    return this.http.patch<any>(`${Endpoints.clientes.base}/contact`, body);
  }

}
